import React from 'react';

class Sermons extends React.Component{

    render(){
        return (
            <div className="row sermons">
            <div className="col-10 offset-1 sermons-title" style={{color: this.props.primeColor}}>
                RECENT SERMONS
                <div className="row" style={{paddingTop:"40px"}}>
                    <div className="col-5 sermons-left">

                    </div>
                    <div className="col-7 sermons-right">
                        <img src={this.props.fields.image.fields.file.url}/>
                        <div className="sermons-link"> <a href="/sermons">SEE ALL SERMONS &gt;</a></div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default Sermons;
